import React, { Component } from 'react';
import { connect } from 'react-redux';
import './AnticipatedCostReport.css';
import AnticipatedCostReportTable from './AnticipatedCostReportTable';
import { getCurrentWorkOrder } from 'selectors/admin/work-orders/work-orders';
import {
  getQuotes,
  getProposals,
} from 'selectors/admin/work-orders/details/details';
import {
  getMiscCosts,
  getEdit,
  getSaving,
  getProposal,
  getAdditionalCostEdit,
  getAdditionalCostSaving,
} from 'components/admin/work-orders/details/anticipated-cost-report/store/selectors';
import {
  setMiscCost,
  setEdit,
  saveQuote,
  setAdditionalCost,
  setAdditionalCostEdit,
  saveProposal,
  updateWorkOrderAcrDocs,
} from 'components/admin/work-orders/details/anticipated-cost-report/store/actions';
import Dropzone from 'react-dropzone';
import uploadPng from 'images/upload.png';
import FilesUploadedViewer from 'components/shared/files/FilesUploadedViewer';
import { getChangeOrders } from 'components/admin/work-orders/details/change-orders/store/selectors';
import { getChangeOrderTasks } from 'components/admin/work-orders/details/change-order-tasks/store/selectors';

class AnticipatedCostReport extends Component {
  constructor(props) {
    super(props);

    props.quotes.forEach(function (quote) {
      if (!props.miscCosts[quote.id]) {
        props.dispatch(setMiscCost(quote.id, quote.misc_cost || ''));
      }
    });

    if (!props.proposal.additionalCost) {
      props.dispatch(
        setAdditionalCost(
          props.workOrder.approved_proposal.cli_additional_cost || '',
          'additionalCost'
        )
      );
    }

    if (!props.proposal.additionalCostDesc) {
      props.dispatch(
        setAdditionalCost(
          props.workOrder.approved_proposal.cli_additional_cost_desc || '',
          'additionalCostDesc'
        )
      );
    }
  }

  handleDocumentsDrop = (documents) => {
    this.props.dispatch(
      updateWorkOrderAcrDocs(this.props.workOrder.id, documents)
    );
  };

  handleDocumentRemove = (documentId) => {
    this.props.dispatch(
      updateWorkOrderAcrDocs(this.props.workOrder.id, null, documentId)
    );
  };

  render() {
    return (
      <div className="anticipated-cost-report">
        <div className="acr-documents-container">
          <div className="dropzone-container">
            <Dropzone
              accept="application/pdf, .doc, .docx, .xls, .xlsx"
              className="building-files-dropzone"
              onDrop={this.handleDocumentsDrop}
            >
              <span>Please drag and drop any file into this area</span>
              <img src={uploadPng} alt="remove" />
            </Dropzone>
          </div>
          <div className="files-viewer">
            <FilesUploadedViewer
              documents={this.props.workOrder.acr_documents}
              showLink={true}
              onDocumentRemove={this.handleDocumentRemove}
            />
          </div>
        </div>
        <AnticipatedCostReportTable
          workOrder={this.props.workOrder}
          proposals={this.props.proposals}
          quotes={this.props.quotes}
          changeOrders={this.props.changeOrders}
          changeOrderTasks={this.props.changeOrderTasks}
          miscCosts={this.props.miscCosts}
          edit={this.props.edit}
          saving={this.props.saving}
          onValueChange={this.onValueChange}
          onEdit={this.onEdit}
          onSave={this.onSave}
          proposal={this.props.proposal}
          additionalCostEdit={this.props.additionalCostEdit}
          additionalCostSaving={this.props.additionalCostSaving}
          onAdditionalCostValueChange={this.onAdditionalCostValueChange}
          onAdditionalCostEdit={this.onAdditionalCostEdit}
          onAdditionalCostSave={this.onAdditionalCostSave}
        />
      </div>
    );
  }

  onValueChange = (quoteId, value) => {
    this.props.dispatch(setMiscCost(quoteId, value));
  };

  onEdit = (quoteId) => {
    this.props.dispatch(setEdit(quoteId));
  };

  onSave = (quoteId) => {
    this.props.dispatch(
      saveQuote(quoteId, { miscCost: this.props.miscCosts[quoteId] })
    );
  };

  onAdditionalCostValueChange = (value, attr) => {
    this.props.dispatch(setAdditionalCost(value, attr));
  };

  onAdditionalCostEdit = () => {
    this.props.dispatch(setAdditionalCostEdit());
  };

  onAdditionalCostSave = () => {
    this.props.dispatch(
      saveProposal(
        this.props.workOrder.approved_proposal.id,
        this.props.proposal
      )
    );
  };
}

export default connect((state) => {
  return {
    workOrder: getCurrentWorkOrder(state),
    quotes: getQuotes(state),
    proposals: getProposals(state),
    changeOrders: getChangeOrders(state),
    changeOrderTasks: getChangeOrderTasks(state),
    miscCosts: getMiscCosts(state),
    edit: getEdit(state),
    saving: getSaving(state),
    proposal: getProposal(state),
    additionalCostEdit: getAdditionalCostEdit(state),
    additionalCostSaving: getAdditionalCostSaving(state),
  };
})(AnticipatedCostReport);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/anticipated-cost-report/AnticipatedCostReport.js